import { module } from 'modujs'
import { gsap } from '../gsap'

export default class TeamList extends module {

    static get settings() {
        return {
            PAGINATION: 12,
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$loadMore = Array.from(this.$('loadMore'))
        this.$list = this.$('list')[0]
        this.$members = Array.from(this.$('member'))
        this.membersCount = this.$members.length
        this.paginationIndex = 0

        gsap.set(this.$members, {
            display: 'none',
        })

        // Events
        this.events = {
            click: {
                loadMore: 'show',
            },
            change: {
                order: 'sort'
            },
        }
    }

    init() {
        this.show(false)
    }

    show(focus=true) {
        this.paginationIndex++

        const $membersToDisplay = this.$members.slice((this.paginationIndex - 1) * TeamList.settings.PAGINATION, (this.paginationIndex * TeamList.settings.PAGINATION))

        // No load more
        if (this.paginationIndex * TeamList.settings.PAGINATION >= this.membersCount) {
            gsap.set(this.$loadMore, {
                opacity: 0
            })
        }
        // Load more
        else {
            gsap.set(this.$loadMore, {
                opacity: 1
            })
        }

        gsap.set($membersToDisplay, {
            clearProps: 'all',
        })

        gsap.from($membersToDisplay, {
            opacity: 0,
            yPercent: 10,
            stagger: 0.1,
            ease: 'power2.out',
            duration: 0.5,
            onStart: () => {
                if(focus !== false) {
                    Array.from(this.$list.children)[(this.paginationIndex - 1) * TeamList.settings.PAGINATION]?.querySelector('button')?.focus?.({ focusVisible: true })
                }
            }
        })
    }

    sort(e) {
        const value = e.curTarget.value

        this.call('scrollTo', { target: this.$el }, 'Scroll')

        gsap.to(this.$members, {
            opacity: 0,
            yPercent: 10,
            stagger: 0.02,
            ease: 'power2.in',
            duration: 0.25,
            onComplete: () => {

                gsap.set(this.$members, {
                    display: 'none',
                })

                // Sort members
                if(value === 'ASC') {
                    this.$members.sort((a, b) => a.dataset.name < b.dataset.name ? -1 : a.dataset.name > b.dataset.name ? 1 : 0)
                } else if(value === 'DESC') {
                    this.$members.sort((a, b) => b.dataset.name < a.dataset.name ? -1 : b.dataset.name > a.dataset.name ? 1 : 0)
                }

                // Reorder DOM
                for(let $member of this.$members) {
                    this.$list.appendChild($member)
                }

                // Reset pagination
                this.paginationIndex = 0

                this.show()
            }
        })
    }

    destroy() {
    }
}
